import React from 'react'

function CustSize() {
  return (
<>
<h2>Custom Size</h2>
<br/>
<p className='p-doc'>width(px)</p>
<code>cust-w-[number in integer]</code>
<br/>
<br/>
<p className='p-doc'>width(px)</p>
<code>cust-w-[number in integer]</code>
<br/>
<br/>
<p className='p-doc'>height(view-height)</p>
<code>cust-vh-[number in integer]</code>
<br/>
<br/>
<p className='p-doc'>width(view-height)</p>
<code>cust-vw-[number in integer]</code>
</>
    )
}

export default CustSize